module.exports = __webpack_public_path__ + "img/icon_img7.6b433518.png";